import React, { ReactNode, useEffect, useState } from 'react';
import { initAuth } from 'samolet-oauth2'; // Импортим метод авторизации
import { captureException } from '@sentry/react';

import { FullScreenSpin } from 'ui';

type AuthProviderType = ({ children }: { children: React.ReactNode }) => JSX.Element;

interface AuthConfigInterface {
  clientId: string;
  allowAnonymous?: boolean; // Если true пропустит без авторизации
}

// Конфиг приложения
const authConfig: AuthConfigInterface = { clientId: __SAMOLET_OAUTH2_PKCE_CLIENT_ID__ };

export const AuthProvider: AuthProviderType = ({ children }: { children: ReactNode }) => {
  const [loading, setLoading] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(__USE_AUTH_TYPE__ === 'SESSION' ? true : false);
  const authorize = async () => {
    try {
      setLoading(true);
      // Вызываем авторизацию
      await initAuth(authConfig);
      setIsAuthorized(true);
    } catch (error) {
      // Обрабатываем ошибки
      console.error(error);
      captureException(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isAuthorized) {
      authorize();
    }
  }, [isAuthorized]);

  if (loading) return <FullScreenSpin />;

  if (!isAuthorized) return <div>Not authorized</div>;

  return <>{children}</>;
};
